import React, { useState, useEffect } from 'react'
import { FaTimes, FaExternalLinkAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import api from '../api/api'

const NotificationBanner = () => {
    const [notifications, setNotifications] = useState([])
    const [dismissedIds, setDismissedIds] = useState([])
    
    useEffect(() => {
        fetchNotifications()
        
        // Load dismissed from localStorage
        const dismissed = JSON.parse(localStorage.getItem('dismissedNotifications') || '[]')
        setDismissedIds(dismissed)
    }, [])
    
    const fetchNotifications = async () => {
        try {
            const { data } = await api.get('/home/notifications/active', {
                params: { userType: 'all' }
            })
            
            const banners = data.notifications.filter(n => n.displayType === 'banner')
            setNotifications(banners)
            
            // Track views
            banners.forEach(n => {
                api.post(`/home/notifications/${n._id}/view`).catch(() => {})
            })
            
        } catch (error) {
            console.error('Error:', error)
        }
    }
    
    const handleDismiss = async (id) => {
        await api.post(`/home/notifications/${id}/dismiss`).catch(() => {})
        
        const newDismissed = [...dismissedIds, id]
        setDismissedIds(newDismissed)
        localStorage.setItem('dismissedNotifications', JSON.stringify(newDismissed))
    }
    
    const handleClick = async (id) => {
        await api.post(`/home/notifications/${id}/click`).catch(() => {})
    }
    
    const getStyles = (type) => {
        const styles = {
            info: 'bg-blue-500 border-blue-600',
            warning: 'bg-yellow-500 border-yellow-600',
            success: 'bg-green-500 border-green-600',
            error: 'bg-red-500 border-red-600',
            maintenance: 'bg-purple-500 border-purple-600'
        }
        return styles[type] || styles.info
    }
    
    const active = notifications.filter(n => !dismissedIds.includes(n._id))
    
    if (active.length === 0) return null
    
    return (
        <div className='w-full z-50'>
            {active.map((n) => (
                <div key={n._id} className={`w-full ${getStyles(n.type)} text-white border-b-2`}>
                    <div className='max-w-[1440px] mx-auto px-4 py-3'>
                        <div className='flex items-center justify-between gap-4'>
                            <div className='text-2xl'>{n.icon}</div>
                            
                            <div className='flex-1'>
                                <p className='text-sm md:text-base'>
                                    <span className='font-bold'>{n.title}</span> - {n.message}
                                </p>
                            </div>
                            
                            {n.actionLink && n.actionText && (
                                <Link
                                    to={n.actionLink}
                                    onClick={() => handleClick(n._id)}
                                    className='bg-white text-blue-600 hover:bg-blue-50 px-4 py-2 rounded font-semibold text-sm flex items-center gap-2'
                                >
                                    {n.actionText}
                                    <FaExternalLinkAlt className='text-xs' />
                                </Link>
                            )}
                            
                            {n.isDismissible && (
                                <button
                                    onClick={() => handleDismiss(n._id)}
                                    className='hover:bg-white/20 p-2 rounded'
                                >
                                    <FaTimes />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default NotificationBanner